const PropTypes = require('prop-types');
/**
 * Created by adderlyjaureguicampos on 06/12/16.
 */
const React = require('react');

const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { formatText } = require('core/i18n').i18n;

require('./autonomousTaxForm.scss');

class AutonomousTaxForm extends React.Component {

    constructor(props) {
        super(props);
        let initialState;
        if (this.props.values) {
            initialState = this.props.values;
        } else {
            initialState = {
                taxDataAutonomousOption_1: false,
                taxDataAutonomousOption_2: false,
                taxDataAutonomousOption_3: false,
                taxDataAutonomousOption_4: false,
                taxDataAutonomousOption_5: false,
                taxDataAutonomousOption_6: false
            };
        }
        this.state = initialState;
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }


    handleCheckboxChange(event) {
        this.setState({[event.target.id] : event.target.checked});
    }

    render() {
        this.props.dataReceiver(this.state);
        const options = [
            {
                value: this.state.taxDataAutonomousOption_1
                , label: formatText('contractsView-checkingAccountAutonomousCheckGroupOption_1')
            },
            {
                value: this.state.taxDataAutonomousOption_2
                , label: formatText('contractsView-checkingAccountAutonomousCheckGroupOption_2')
            },
            {
                value: this.state.taxDataAutonomousOption_3
                , label: formatText('contractsView-checkingAccountAutonomousCheckGroupOption_3')
            },
            {
                value: this.state.taxDataAutonomousOption_4
                , label: formatText('contractsView-checkingAccountAutonomousCheckGroupOption_4')
            },
            {
                value: this.state.taxDataAutonomousOption_5
                , label: formatText('contractsView-checkingAccountAutonomousCheckGroupOption_5')
            },
            {
                value: this.state.taxDataAutonomousOption_6
                , label: formatText('contractsView-checkingAccountAutonomousCheckGroupOption_6')
            }
                ];
        let checkboxes = [];
            options.forEach((option, index) => {
            const name = 'taxDataAutonomousOption_' + (index + 1);
            checkboxes.push(
                <div>
                    <OKCheckbox
                        idName={name}
                        label={option.label}
                        value={option.value}
                        onChange={this.handleCheckboxChange}/>
                </div>
            )
        });

        return (
            <div >
                <div className="autonomous-tax-form__form-title">{formatText('contractsView-checkingAccountAutonomousCheckGroupTitle')}</div>
                {checkboxes}
            </div>
        )
    }
}

AutonomousTaxForm.propTypes = {
    dataReceiver: PropTypes.func,
    values: PropTypes.object
};

module.exports = AutonomousTaxForm;